import React from "react";
import { LeadershipRole, leadershipRoleNaming } from "../../api/typesDc";
import { useTranslation } from "react-i18next";
import AutoComplete from "../AutoComplete";

const LeaderShipRolesAutocomplete = (props:any) => {
    const { selectedValues, manageSelect, isReadOnly } = props;
    const [t] = useTranslation();
    const options = [
      { value: LeadershipRole.LR_HEAD_OF_DEV_DEP, name: t(leadershipRoleNaming[LeadershipRole.LR_HEAD_OF_DEV_DEP]) },
      { value: LeadershipRole.LR_U18_COACH, name: t(leadershipRoleNaming[LeadershipRole.LR_U18_COACH]) },
      { value: LeadershipRole.LR_U15_COACH, name: t(leadershipRoleNaming[LeadershipRole.LR_U15_COACH]) },
      { value: LeadershipRole.LR_U12_COACH, name: t(leadershipRoleNaming[LeadershipRole.LR_U12_COACH]) },
      { value: LeadershipRole.LR_ACADEMY_TC, name: t(leadershipRoleNaming[LeadershipRole.LR_ACADEMY_TC]) },
    ];

    const manageRolesSelect = (d:any) => {
      let tempLeaderRoles = [];
      const index = selectedValues.findIndex((item:any) => item == d.value);
      if(index !== -1) {
        tempLeaderRoles = selectedValues.filter((item:any) => item != d.value);
      } else {
        tempLeaderRoles = [...selectedValues, d.value];
      }
      manageSelect(tempLeaderRoles);
    }

    return (
        <>
            <AutoComplete 
            options={options}
            selectedValues={selectedValues}
            handleMenuClick={manageRolesSelect} 
            label={t('DC_5_LEADERSHIP_ROLE')}
            clickReset={() => {manageSelect([])}}
            isMultiple={true}
            isReadOnly={isReadOnly}
            />
        </>
    );
}

export default LeaderShipRolesAutocomplete;